"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckBetSlipOptions = void 0;
var CheckBetSlipOptions;
(function (CheckBetSlipOptions) {
    CheckBetSlipOptions[CheckBetSlipOptions["None"] = 0] = "None";
    CheckBetSlipOptions[CheckBetSlipOptions["Stake"] = 1] = "Stake";
    CheckBetSlipOptions[CheckBetSlipOptions["BranchBetSettings"] = 2] = "BranchBetSettings";
    CheckBetSlipOptions[CheckBetSlipOptions["UserAge"] = 8] = "UserAge";
    CheckBetSlipOptions[CheckBetSlipOptions["GameStates"] = 16] = "GameStates";
    CheckBetSlipOptions[CheckBetSlipOptions["GameStartDates"] = 32] = "GameStartDates";
    CheckBetSlipOptions[CheckBetSlipOptions["OddValueChanges"] = 64] = "OddValueChanges";
    CheckBetSlipOptions[CheckBetSlipOptions["OddStates"] = 128] = "OddStates";
    CheckBetSlipOptions[CheckBetSlipOptions["MaximumGainRules"] = 256] = "MaximumGainRules";
    CheckBetSlipOptions[CheckBetSlipOptions["FeeRules"] = 512] = "FeeRules";
    CheckBetSlipOptions[CheckBetSlipOptions["TaxRules"] = 1024] = "TaxRules";
    CheckBetSlipOptions[CheckBetSlipOptions["Limits"] = 4096] = "Limits";
    CheckBetSlipOptions[CheckBetSlipOptions["CustomCheck"] = 8192] = "CustomCheck";
    CheckBetSlipOptions[CheckBetSlipOptions["UserAccount"] = 16384] = "UserAccount";
    CheckBetSlipOptions[CheckBetSlipOptions["Combinability"] = 32768] = "Combinability";
    CheckBetSlipOptions[CheckBetSlipOptions["All"] = 131071] = "All";
})(CheckBetSlipOptions = exports.CheckBetSlipOptions || (exports.CheckBetSlipOptions = {}));
